import { Directive, ElementRef } from '@angular/core';
import { PlatformService } from '@shared/services/platform.service';
import { Overscroll } from '@shared/directives/overscroll/overscroll';
import { GradientClass } from '@shared/directives/overscroll/enums/overscroll.enums';

/** Добавляет градиент по нижней границе элемента, если есть вертикальный скролл */
@Directive({
  selector: '[di-overscrollY]',
  standalone: true,
})
export class OverscrollYDirective extends Overscroll {
  constructor(public element: ElementRef, public platform: PlatformService) {
    super(element, platform);
  }

  detectScrollPosition(eventTarget: EventTarget | null): void {
    const element: HTMLElement = eventTarget as HTMLElement;

    const hasBottomOverscroll: boolean =
      Math.ceil(element.scrollTop) + element.clientHeight !==
      element.scrollHeight;

    if (hasBottomOverscroll) {
      element.classList.add(GradientClass.Bottom);
    } else {
      element.classList.remove(GradientClass.Bottom);
    }
  }
}
